import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsOneStep.AddPersonWizard.DetailsStep', {
    personalDetails: 'Personal details',
    requiredField: 'Field is required',
});
